// import * as yup from "yup";

// export const companySchema = yup.object({
//     companyName: yup
//         .string()
//         .required("Company name is required"),

//     logo: yup
//         .mixed<FileList>()
//         .test("fileExists", "Logo is required", function (value) {
//             const hasExistingLogo = (this.options.context as any)?.hasExistingLogo;

//             if (hasExistingLogo) return true;

//             return value && value.length > 0;
//         }),
// });

import * as yup from "yup";

export const companySchema = yup.object({
    companyName: yup
        .string()
        .required("Company name is required"),

    logo: yup.mixed().notRequired(), // ✅ no conditional logic here
});